export const portalVersion = "5.2"; 
